module.exports = __webpack_public_path__ + "d2cb4f839f7cf25fe08dbce3b4a97441.pdf";